import {CreatePostReplyApiProps, ReplyEntry} from "../../../../types/support/board";

import ReplyEditRow from "../../../../components/common/ReplyEditRow";
import {useEditPostReply} from "../hooks/useEditPostReply";

interface ReplyEditRowProps {
    data: ReplyEntry;
    onCanceled: (key:string) => void;
    postId: string;
}

export default function BoardReplyCreateRow(props: ReplyEditRowProps) {
    const {data, onCanceled, postId} = props;

    const {
        removeFile,
        handleButtonClick,
        UploadUI,
        inputData,
        setInputData,
        createPostReply
    } = useEditPostReply({data: data, onCanceled, postId: postId});

    return <ReplyEditRow setter={setInputData}
                         data={inputData}
                         removeFile={removeFile}
                         handleButtonClick={handleButtonClick}
                         UploadUI={UploadUI}
                         updateReply={()=>createPostReply(inputData as CreatePostReplyApiProps)}
                         onCanceled={()=>onCanceled(inputData.postReplyId)}/>
}